<template>
  <div class="tenant-logo">
    <img
      v-if="tenantStore.tenantLogo && !showTextFallback"
      :src="tenantStore.tenantLogo"
      :alt="tenantStore.tenantName + ' Logo'"
      :style="{
        '--tenant-primary-color': tenantStore.tenantPrimaryColor,
      }"
      class="logo-image"
      @error="handleImageError"
    />
    <div
      v-else
      class="logo-text"
      :style="{
        '--tenant-primary-color': tenantStore.tenantPrimaryColor,
        color: tenantStore.tenantPrimaryColor,
      }"
    >
      {{ tenantStore.tenantDisplayName }}
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useTenantStore } from "@/stores/tenantStore";

const tenantStore = useTenantStore();
const showTextFallback = ref(false);

function handleImageError(event) {
  // Show text fallback instead of broken image
  showTextFallback.value = true;
}
</script>

<style scoped>
.tenant-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.logo-image {
  max-height: 40px;
  max-width: 200px;
  height: auto;
  width: auto;
  object-fit: contain;
  transition: filter 0.3s ease;
}

.logo-image:hover {
  filter: brightness(1.1);
}

/* Tenant-specific styling if needed */
.logo-image {
  border: 2px solid transparent;
}

/* Use the CSS custom property set from the tenant's primary color */
.logo-image:focus {
  border-color: var(--tenant-primary-color);
  outline: none;
}

/* Text fallback styling */
.logo-text {
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  padding: 8px 16px;
  border: 2px solid var(--tenant-primary-color);
  border-radius: 8px;
  background: linear-gradient(
    135deg,
    var(--tenant-primary-color) 10,
    transparent
  );
  transition: all 0.3s ease;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 200px;
}

.logo-text:hover {
  background: linear-gradient(
    135deg,
    var(--tenant-primary-color) 20,
    var(--tenant-primary-color) 05
  );
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
